module.exports = __webpack_public_path__ + "static/img/welcome_back_icon.ecc00558.svg";